/**
 * Mode-agnostic calendar `:ui` shared by the date-range picker and the datetime
 * filter calendars so they render with the same weekday header, month heading,
 * and grid styling. Selection styling is layered on per mode (single vs range).
 */
const calendarBaseUi = {
	gridBody: 'gap-y-0.5',
	gridRow: 'place-items-stretch',
	headCell: 'text-dimmed font-normal',
	heading: 'text-md font-medium',
};

/** Single-select calendars: a selected day is a filled rounded square; hover shows a primary ring. */
export const calendarSingleUi = {
	...calendarBaseUi,
	cellTrigger: 'm-0 rounded-md data-[selected]:bg-primary data-[selected]:text-inverted hover:bg-transparent data-[highlighted]:bg-transparent hover:border-2 hover:border-primary hover:data-[selected]:border-0',
};

/** Range calendars: endpoints are filled squares, the span is tinted, and unavailable days are dimmed. */
export const calendarRangeUi = {
	...calendarBaseUi,
	cell: '[&:has([data-selected])]:bg-primary/15 [&:has([data-selection-start])]:rounded-s-md [&:has([data-selection-end])]:rounded-e-md',
	cellTrigger: 'm-0 rounded-md data-[selected]:bg-transparent data-[selected]:text-highlighted data-[selected]:data-[selection-start]:bg-primary data-[selected]:data-[selection-start]:text-inverted data-[selected]:data-[selection-start]:rounded-md data-[selected]:data-[selection-end]:bg-primary data-[selected]:data-[selection-end]:text-inverted data-[selected]:data-[selection-end]:rounded-md hover:bg-transparent data-[highlighted]:bg-transparent hover:border-2 hover:border-primary hover:data-[selection-start]:border-0 hover:data-[selection-end]:border-0 data-[unavailable]:opacity-35 data-[unavailable]:cursor-not-allowed data-[unavailable]:pointer-events-auto data-[unavailable]:no-underline data-[unavailable]:hover:bg-transparent data-[unavailable]:hover:border-0',
};
